import { styled } from '@mui/material/styles';
import { TableRow, TableCell, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { StyledSubTableRowProps } from './types';

const StyledSubTableRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'index' && prop !== 'detailsLength',
})<StyledSubTableRowProps>(({ index, detailsLength, theme }) => ({
  backgroundColor:
    index % 2 === 0 ? NEW_COLORS.GRAYSCALE[25] : NEW_COLORS.GRAYSCALE[100],
  '& td:first-of-type': {
    borderBottomLeftRadius: index === detailsLength - 1 ? 8 : 0,
  },
  '& td:last-of-type': {
    borderBottomRightRadius: index === detailsLength - 1 ? 8 : 0,
  },
  [theme.breakpoints.down('md')]: {
    '& td:first-of-type': {
      borderBottomLeftRadius: 0,
    },
    '& td:last-of-type': {
      borderBottomRightRadius: 0,
    },
  },
}));

const StyledSubTableCell = styled(TableCell)({
  borderBottom: 'unset',
});

const StyledEmptyTableCell = styled(TableCell)({
  borderBottom: 'unset',
  borderTop: 'unset',
});

const StyledSubTableTypography = styled(Typography)({
  maxWidth: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
});

export {
  StyledSubTableTypography,
  StyledEmptyTableCell,
  StyledSubTableCell,
  StyledSubTableRow,
};
